var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"6"}}),_c('Device'),_c('CallMe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }